exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.checkbox[data-v-66ee775a] label {\n  font-family: Avenir;\n  font-size: 22.3px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 0.3px;\n  color: #090c9b;\n}\n", ""]);

